import { useState } from 'react'
import style from './style.module.scss'
import clsx from 'clsx'
import useMediaQuery from '@mui/material/useMediaQuery'
import ProfileMenuMainHeader from './Profile'
import TopHeader from '../../Top'
import { ReactComponent as Plus } from './plus-ico.svg'
import { ReactComponent as Arrow } from './arrow-right-mobile.svg'
import SearchMainHeader from '../Search'

const MenuMain = ({ menu, open, langs, responsiveMenu }) => {
    const containerClasses = clsx({
        [style.container]: true,
        [style.open]: open,
    })

    const [active, setActive] = useState(null)

    const tablet = useMediaQuery(`(max-width:${style.tabletBreakpoint})`)
    const mobile = useMediaQuery(`(max-width:${style.mobileBreakpoint})`)

    /**
     * Update state with current menu to get only one open menu
     * @param {number} index
     */
    const activeMenu = (index) => {
        if (!tablet) return

        setActive((old) => (old === index ? null : index))
    }

    return (
        <div className={containerClasses} id="container_header">
            {tablet && <TopHeader langs={langs} menu={responsiveMenu} />}
            {mobile && <SearchMainHeader />}
            <div className={style.content}>
                {menu &&
                    Object.values(menu).map((m, index) => (
                        <div key={m.ID} className={clsx(style.item, active === index ? style.active : undefined)}>
                            <div className={style.head} onClick={() => activeMenu(index)}>
                                {m.title}
                                {tablet && (
                                    <div className={style.cross}>
                                        <Plus />
                                    </div>
                                )}
                            </div>

                            <div className={style.child}>
                                {m.children.map((child) => (
                                    <a key={child.ID} href={child.url}>
                                        <span dangerouslySetInnerHTML={{ __html: child.title }} />
                                        {tablet && <Arrow />}
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}

                <ProfileMenuMainHeader />
            </div>
        </div>
    )
}

export default MenuMain
